import React from 'react';

export default function Marquee({ items = [], speed = 40, className = '' }) {
  // items: array of strings
  const loop = [...items, ...items, ...items, ...items];
  return (
    <div className={`relative overflow-hidden py-4 ${className}`}>
      <div
        className="flex whitespace-nowrap"
        style={{
          animation: `marquee ${speed}s linear infinite`,
        }}
      >
        {loop.map((t, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="px-8 text-sm md:text-base tracking-[0.25em] uppercase text-white/80">
              {t}
            </span>
            <span className="h-[3px] w-[3px] rounded-full bg-[var(--accent)]" />
            <span className="px-8 text-sm md:text-base tracking-[0.25em] text-[var(--accent)]">—</span>
            <span className="h-[3px] w-[3px] rounded-full bg-[var(--accent)]" />
          </span>

        ))}
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-25%); }
        }
      `}</style>
    </div>
  );
}
